import { UserAbility } from "modules/user/config/permissions/Can";

export const ability: Partial<UserAbility> = {
  project: {
    read: ["all"],
    create: ["master"],
    delete: ["master"],
    update: ["master", "executive", "program_manager", "administrator"],
    config: ["master", "executive", "program_manager", "administrator"]
  },
  group: {
    read: ["all"],
    create: ["master"],
    update: ["master"],
    delete: ["master"],
    config: ["master"]
  },
  collection: {
    read: ["all"],
    create: ["master"],
    update: ["master"],
    delete: ["master"],
    config: ["master"]
  },
  shared_experiments: {
    read: [
      "master",
      "administrator",
      "program_manager",
      "staff",
      "client",
      "client_viewer",
      "team_viewer"
    ],
    create: ["master", "program_manager", "administrator", "staff"],
    update: ["master", "program_manager", "administrator"],
    delete: ["master", "program_manager", "administrator"],
    config: ["master", "program_manager", "administrator"]
  },
  shared_roadmap: {
    read: [
      "master",
      "administrator",
      "program_manager",
      "staff",
      "client",
      "client_viewer",
      "team_viewer"
    ],
    create: ["master", "program_manager", "administrator", "staff", "client"],
    update: ["master", "program_manager", "administrator", "staff", "client"],
    delete: ["master", "program_manager", "administrator"],
    config: ["master", "program_manager", "administrator"]
  },
  team: {
    read: [
      "master",
      "administrator",
      "program_manager",
      "staff",
      "client",
      "client_viewer",
      "team_viewer"
    ],
    create: ["master", "program_manager", "administrator"],
    update: ["master", "program_manager", "administrator"],
    delete: ["master", "program_manager", "administrator"],
    config: ["master", "program_manager", "administrator"]
  },
  project_notifications: {
    read: ["all"],
    create: ["master", "program_manager", "administrator"],
    update: ["master", "program_manager", "administrator"],
    delete: ["master", "program_manager", "administrator"],
    config: ["master", "program_manager", "administrator"]
  }
};
